import React__default from 'react';
import { u as useOpenChannelContext } from '../../chunks/bundle-c6Xd_0m8.js';
import OpenChannelInput from './OpenChannelInput.js';
import FrozenNotification from './FrozenChannelNotification.js';
import OpenchannelConversationHeader from './OpenChannelHeader.js';
import PlaceHolder, { PlaceHolderTypes } from '../../ui/PlaceHolder.js';
import OpenChannelMessageList from './OpenChannelMessageList.js';
import '../../chunks/bundle-d1cOX5nv.js';
import '../../chunks/bundle-CxLxJCBu.js';
import '../../chunks/bundle-DS1EhNtb.js';
import '../../chunks/bundle-DXFVroy5.js';
import '@sendbird/uikit-tools';
import '../../withSendbird.js';
import '../../chunks/bundle-DRpjMk0B.js';
import '../../chunks/bundle-BA9oFJ90.js';
import '@sendbird/chat/groupChannel';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-DiK8ifY3.js';
import '../../chunks/bundle-C-nZYnmy.js';
import '../../chunks/bundle-DP3z2QNm.js';
import '../../chunks/bundle-kFa80LJe.js';
import 'react-dom';
import '../../chunks/bundle-Ci-RNuvu.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import '../../chunks/bundle-CjJk57u5.js';
import '../../ui/Icon.js';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import '../../chunks/bundle-DKdROCX_.js';
import '@sendbird/chat/openChannel';
import '../../chunks/bundle-DdJ9pMWn.js';
import '../../useSendbirdStateContext.js';
import '../../chunks/bundle-BzR1dD25.js';
import '../../ui/SortByRow.js';
import '../../chunks/bundle-DXKWyDSR.js';
import '../../chunks/bundle-mqagBpi9.js';
import '../../chunks/bundle-B5N-CojP.js';
import '../../chunks/bundle-C_zEpfCP.js';
import '../../ui/MessageInput.js';
import '../../chunks/bundle-D2GzZ_yy.js';
import '../../chunks/bundle-CpMvhj21.js';
import '../../chunks/bundle-GawAxqNK.js';
import 'dompurify';
import '../../chunks/bundle-B5pWUwTI.js';
import '../../chunks/bundle-CiR8AZTC.js';
import '../../chunks/bundle-Bs4dlPq1.js';
import '../../chunks/bundle-AmtSwuex.js';
import '../../chunks/bundle-DOfhjbKd.js';
import '../../ui/ImageRenderer.js';
import '../../ui/Loader.js';
import '../../chunks/bundle-Dq0ggazV.js';
import './OpenChannelMessage.js';
import '../../chunks/bundle-CewnJAub.js';
import '../../ui/OpenchannelUserMessage.js';
import '../../ui/UserProfile.js';
import '../../sendbirdSelectors.js';
import '../../chunks/bundle-D4d941oR.js';
import '../../chunks/bundle-CqNbtpjG.js';
import '../../chunks/bundle-QsOiwa9F.js';
import '../../ui/OpenChannelAdminMessage.js';
import '../../ui/OpenchannelOGMessage.js';
import '../../ui/LinkLabel.js';
import '../../chunks/bundle-AV2qqH9G.js';
import '../../Message/context.js';
import '../../ui/MentionLabel.js';
import '../../ui/OpenchannelThumbnailMessage.js';
import '../../ui/OpenchannelFileMessage.js';
import '../../ui/TextButton.js';
import '../../chunks/bundle-B5157rdG.js';
import '../../ui/DateSeparator.js';
import '../../ui/FileViewer.js';
import '../../chunks/bundle-CH6t4mkR.js';
import '../../chunks/bundle-DcPIDUrE.js';
import '../../chunks/bundle-gBmMoaTG.js';
import '../../chunks/bundle-BjAeG049.js';
import '../../chunks/bundle-AJS7Mngy.js';
import '@sendbird/chat/message';
import '../../Channel/utils/compareMessagesForGrouping.js';

var COMPONENT_CLASS_NAME = 'sendbird-openchannel-conversation';
var OpenChannelUI = function (_a) {
    var renderMessage = _a.renderMessage, renderHeader = _a.renderHeader, renderPlaceHolderEmptyList = _a.renderPlaceHolderEmptyList, renderPlaceHolderError = _a.renderPlaceHolderError, renderPlaceHolderLoading = _a.renderPlaceHolderLoading, renderMessageInput = _a.renderMessageInput, renderInput = _a.renderInput;
    var _b = useOpenChannelContext(), currentOpenChannel = _b.currentOpenChannel, amIBanned = _b.amIBanned, loading = _b.loading, isInvalid = _b.isInvalid, messageInputRef = _b.messageInputRef, conversationScrollRef = _b.conversationScrollRef;
    if (!currentOpenChannel
        || !(currentOpenChannel === null || currentOpenChannel === void 0 ? void 0 : currentOpenChannel.url)
        || amIBanned) {
        return ((renderPlaceHolderError === null || renderPlaceHolderError === void 0 ? void 0 : renderPlaceHolderError())
            || React__default.createElement("div", { className: COMPONENT_CLASS_NAME },
                React__default.createElement(PlaceHolder, { type: PlaceHolderTypes.NO_CHANNELS })));
    }
    if (loading) {
        return ((renderPlaceHolderLoading === null || renderPlaceHolderLoading === void 0 ? void 0 : renderPlaceHolderLoading())
            || React__default.createElement("div", { className: COMPONENT_CLASS_NAME },
                React__default.createElement(PlaceHolder, { type: PlaceHolderTypes.LOADING })));
    }
    if (isInvalid) {
        return ((renderPlaceHolderError === null || renderPlaceHolderError === void 0 ? void 0 : renderPlaceHolderError())
            || React__default.createElement("div", { className: COMPONENT_CLASS_NAME },
                React__default.createElement(PlaceHolder, { type: PlaceHolderTypes.WRONG })));
    }
    var renderInputComponent = renderMessageInput || renderInput;
    return (React__default.createElement("div", { className: COMPONENT_CLASS_NAME },
        (renderHeader === null || renderHeader === void 0 ? void 0 : renderHeader()) || React__default.createElement(OpenchannelConversationHeader, null),
        (currentOpenChannel === null || currentOpenChannel === void 0 ? void 0 : currentOpenChannel.isFrozen) && React__default.createElement(FrozenNotification, null),
        React__default.createElement(OpenChannelMessageList, { ref: conversationScrollRef, renderMessage: renderMessage, renderPlaceHolderEmptyList: renderPlaceHolderEmptyList }),
        (renderInputComponent === null || renderInputComponent === void 0 ? void 0 : renderInputComponent()) || React__default.createElement(OpenChannelInput, { ref: messageInputRef })));
};

export { OpenChannelUI as default };
//# sourceMappingURL=OpenChannelUI.js.map
